const MaterialTermsQuery = (id) => {
    return `
    query {
        getMaterialTermsById(id: "${id}") {
          id
          group_id,
          form_id,
          MaterialTermsFormData {
            new_profile_material_terms_profile_name,
            new_profile_material_terms_section_number,
            new_profile_material_terms_summary,
            new_profile_material_terms_details,
            
        }
        }
      }
      `
}

export const MaterialTermssQuery = (id) => {
    return `
    query {
        getMaterialTermsByIds(ids: ${id}) {
          id
          group_id,
          form_id,
          MaterialTermsFormData {
            new_profile_material_terms_profile_name,
            new_profile_material_terms_section_number,
            new_profile_material_terms_summary,
            new_profile_material_terms_details
        }
        }
      }
      `
}

export default MaterialTermsQuery